// ----------------------------------------------------------------------

export default function CssBaseline() {
    return {
        MuiCssBaseline: {
            styleOverrides: {
                '.MuiBox-root.counter': {
                    backgroundColor: '#59a314',
                    color: '#fff',
                    padding: '5px 20px 3px',
                    fontWeight: 100,
                    borderRadius: '50px',
                    marginLeft: '25px',
                    minWidth: '85px',
                    textAlign: 'center',
                    fontVariantNumeric: 'lining-nums',
                    fontWeight: 300,
                },
            },
        },
    };
}
